import { deleteTag as _deleteTag } from '@griply/services';
import { deleteDoc, doc, getFirestore } from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { ID } from 'shared/types/id';

export const deleteTag = async (id: ID): Promise<void> =>
  _deleteTag({
    tagId: id,
    db: getFirestore(),
    doc,
    deleteDoc,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.DeleteTag,
        error,
      }),
  });
